import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from "@angular/core";
import { Router } from "@angular/router";

import { IconComponent } from "../../../shared/components/icon/icon.component";
import { AUTH_PROVIDER } from "../../../core/auth/auth-provider.token";

@Component({
  selector: "app-unauthorized",
  standalone: true,
  imports: [IconComponent],
  templateUrl: "./unauthorized.component.html",
  styleUrl: "./unauthorized.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnauthorizedComponent {
  private readonly router = inject(Router);

  private readonly authProvider = inject(AUTH_PROVIDER);

  protected readonly loading = signal<boolean>(false);

  protected goToServiceProviders(): void {
    this.router.navigate(["/service-providers"]);
  }

  protected signOut(): void {
    this.loading.set(true);
    // logout() performs a redirect to the IdP and back to /login.
    void this.authProvider.logout();
  }
}
